import React from "react";
import classNames from "classnames";

import { NUM_ITEMS_PAGINATION } from "../../common/variables";
import { getParameterByName } from "../../common/functions";

import "./Pagination.scss";

const Pagination = ({ getFnRequest, ...props }) => {
  if (!props.showPagination) {
    return null;
  }

  if (props.loading) {
    return (
      <div id="pagination" className="loading">
        Cargando...
      </div>
    );
  }

  const { totalCount, next, previous } = props;

  const pages = Math.ceil(totalCount / NUM_ITEMS_PAGINATION);

  const currentPage = next
    ? Number(getParameterByName(next, "page")) - 1
    : Number(getParameterByName(previous, "page")) + 1;

  const status = `pag ${currentPage} / ${pages}`;

  return (
    <div id="pagination">
      {previous && (
        <PaginationBack
          className="link"
          onClick={() => getFnRequest(previous)}
        />
      )}
      {next === null && (
        <PaginationNext className="separator__left grey" status={status} />
      )}

      {previous && next && <div className="separation">{status}</div>}

      {previous === null && (
        <PaginationBack className="separator__right grey" status={status} />
      )}
      {next && (
        <PaginationNext className="link" onClick={() => getFnRequest(next)} />
      )}
    </div>
  );
};

const PaginationBack = ({ className, status, onClick }) => (
  <div className={classNames({ [className]: className })} onClick={onClick}>
    <i className={classNames("fas", "fa-chevron-left")} /> Atrás{" "}
    <span className="status">{status}</span>
  </div>
);

const PaginationNext = ({ className, status, onClick }) => (
  <div className={classNames({ [className]: className })} onClick={onClick}>
    <span className="status">{status}</span> Siguiente{" "}
    <i className={classNames("fas", "fa-chevron-right")} />
  </div>
);

export default Pagination;
